import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Special from './containers/brand/Services/Special';
import Dance from './containers/brand/Services/Dance';
import Music from './containers/brand/Services/Music';
import MartialArt from './containers/brand/Services/Karate';
import Yoga from './containers/brand/Services/Yoga';
import HomeTuition from './containers/brand/Services/HomeTuition';
import Contact from './containers/blog/Blog';
import StudentsForTeachers from './containers/brand/Services/StudentsForTeachers';
import Login from './components/Admin/login';
import Dashboard from './components/Admin/Dashboard';
import PrivateRoute from "./components/Admin/PrivateRoute";
import AuthProvider from './components/Admin/AuthContext';
import CreateJob from './components/Admin/features/createJob';
const App = () => (
  <AuthProvider>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/special" element={<Special />} />
      <Route path="/dance" element={<Dance />} />
      <Route path="/music" element={<Music />} />
      <Route path="/martialArt" element={<MartialArt />} />
      <Route path="/yoga" element={<Yoga />} />
      <Route path="/homeTution" element={<HomeTuition />} />
      <Route path="/students-for-teachers" element={<StudentsForTeachers />} />
      
      {/* Admin */}
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/create"
        element={
          <PrivateRoute>
            <CreateJob />
          </PrivateRoute>
        }
      />
      
    </Routes>
  </AuthProvider>
);

export default App;
